/**
 * Language constants and utilities
 * Maps language codes (ISO 639-1) to display names
 */

// Common languages with their ISO 639-1 codes
export const SUPPORTED_LANGUAGES = [
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Spanish' },
    { code: 'fr', name: 'French' },
    { code: 'de', name: 'German' },
    { code: 'it', name: 'Italian' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'ru', name: 'Russian' },
    { code: 'zh', name: 'Chinese' },
    { code: 'ja', name: 'Japanese' },
    { code: 'ko', name: 'Korean' },
    { code: 'ar', name: 'Arabic' },
    { code: 'he', name: 'Hebrew' },
    { code: 'hi', name: 'Hindi' },
    { code: 'nl', name: 'Dutch' },
    { code: 'pl', name: 'Polish' },
    { code: 'tr', name: 'Turkish' },
    { code: 'vi', name: 'Vietnamese' },
    { code: 'th', name: 'Thai' },
    { code: 'id', name: 'Indonesian' },
    { code: 'cs', name: 'Czech' },
    { code: 'sv', name: 'Swedish' },
    { code: 'da', name: 'Danish' },
    { code: 'fi', name: 'Finnish' },
    { code: 'no', name: 'Norwegian' },
    { code: 'el', name: 'Greek' },
    { code: 'hu', name: 'Hungarian' },
    { code: 'ro', name: 'Romanian' },
    { code: 'uk', name: 'Ukrainian' },
    { code: 'bg', name: 'Bulgarian' },
    { code: 'hr', name: 'Croatian' },
    { code: 'sk', name: 'Slovak' },
    { code: 'sl', name: 'Slovenian' },
    { code: 'et', name: 'Estonian' },
    { code: 'lv', name: 'Latvian' },
    { code: 'lt', name: 'Lithuanian' },
];

/**
 * Get language name by code
 * @param {string} code - ISO 639-1 language code
 * @returns {string} Language name
 */
export const getLanguageNameByCode = (code) => {
    const language = SUPPORTED_LANGUAGES.find(lang => lang.code === code);
    return language ? language.name : code.toUpperCase();
};

/**
 * Get language code by name
 * @param {string} name - Language name
 * @returns {string|null} Language code or null if not found
 */
export const getLanguageCodeByName = (name) => {
    const language = SUPPORTED_LANGUAGES.find(lang => lang.name === name);
    return language ? language.code : null;
};

/**
 * Get all language codes
 * @returns {string[]} Array of language codes
 */
export const getAllLanguageCodes = () => {
    return SUPPORTED_LANGUAGES.map(lang => lang.code);
};
